import React from "react";
import Drawer from "rc-drawer";
import { bool, func, element, string } from "prop-types";
import Head from "pages/_components/Head";
import classNames from "classnames";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";

export default function ButtonDrawer({
    content,
    title,
    width,
    showDrawerRemote,
    closeRemotely,
    isDesktop,
    backButton,
    centerContentClassName,
    contentClassName,
    headerClassName,
    drawerClassName,
    noBlueHeader,
    header,
    notificationContent,
}) {
    ButtonDrawer.propTypes = {
        content: element.isRequired,
        title: string,
        centerContentClassName: string,
        contentClassName: string,
        width: string,
        showDrawerRemote: bool.isRequired,
        closeRemotely: func.isRequired,
        isDesktop: bool,
        backButton: bool,
        headerClassName: string,
        drawerClassName: string,
        noBlueHeader: bool,
        header: element,
        notificationContent: element,
    };
    ButtonDrawer.defaultProps = {
        title: "",
        width: "",
        centerContentClassName: "",
        contentClassName: "",
        isDesktop: true,
        backButton: false,
        headerClassName: "",
        drawerClassName: "",
        noBlueHeader: false,
        header: undefined,
        notificationContent: undefined,
    };
    const uxDashboardImprovements = isUxDashboardImprovementsEnabled();
    return (
        <>
            <Drawer
                width={width}
                open={showDrawerRemote}
                handler={false}
                placement="right"
                level={null}
                className={drawerClassName}
                onClose={() => closeRemotely(!showDrawerRemote)}>
                <div className={classNames("drawer-content-inner", { "layout-v3": uxDashboardImprovements })}>
                    <Head
                        onBack={backButton && closeRemotely}
                        title={title}
                        onClose={!backButton && closeRemotely}
                        closeImageWhite={!isDesktop}
                        headerClassName={classNames(`${headerClassName}`, {
                            "blue-main-header-mobile blue-main-title-mobile": !isDesktop && !noBlueHeader,
                            "background-white": !isDesktop && noBlueHeader,
                        })}
                        centerContentClassName={centerContentClassName}
                        hideNavbarInMobile
                        navbarClassName="navbar-header-blue">
                        {header}
                    </Head>
                    {!uxDashboardImprovements && notificationContent}
                    <div className={contentClassName}>
                        {showDrawerRemote && (
                            <div>
                                {React.cloneElement(content, {
                                    ...content.props,
                                    closeDrawer: () => closeRemotely(!showDrawerRemote),
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </Drawer>
        </>
    );
}
